// extracted by mini-css-extract-plugin
export default {"pinContent":"MapPanel_pinContent__4y+e5"};